import { JsonLd } from 'src/components/JsonLd'
import type { CollectionPage } from 'schema-dts'
import PageSeo from 'src/components/Seo'
import { absoluteSeoUrl, seoText, seoTitle } from 'src/functions/seo'
import { hrefForBrandPath } from 'src/functions/navigationBreadcrumbs'
import type { tBrands } from 'src/shared/frontendTypes/brand'
import shopInfos from 'template/infos'

const title = 'Marken von A bis Z'
const description = `Alle Marken bei ${shopInfos.name} im Überblick. Finden Sie Ihre Lieblingsmarke und entdecken Sie die Produkte im Sortiment.`

export const buildBrandDirectoryData = (brands: tBrands): CollectionPage => {
  const url = absoluteSeoUrl('/brands')
  const items = brands.flatMap(brand => {
    const href = hrefForBrandPath(brand.path, brand.id)
    const name = seoText(brand.titel)
    return href && name ? [{ name, url: absoluteSeoUrl(href) }] : []
  })

  return {
    '@type': 'CollectionPage',
    '@id': `${url}#webpage`,
    url,
    name: seoTitle(title),
    description,
    isPartOf: { '@id': `${shopInfos.url.replace(/\/$/, '')}#website` },
    inLanguage: shopInfos.locale.replace('_', '-'),
    ...(items.length ? {
      mainEntity: {
        '@type': 'ItemList',
        '@id': `${url}#itemlist`,
        numberOfItems: items.length,
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          ...item,
        })),
      },
    } : {}),
  }
}

const Seo = ({ brands }: { brands: tBrands }) => <>
  <PageSeo title={title} description={description} canonical='/brands' />
  <JsonLd<CollectionPage> item={{ '@context': 'https://schema.org', ...buildBrandDirectoryData(brands) }} />
</>

export default Seo
